export const InventoryEnum = [
    {text: "انبار مرکزی خشک", value: 0},
    {text: "انبار مرکزی روزانه", value: 1},
    {text: "انبار مرکزی یخچال", value: 2},
]